module.exports = __webpack_public_path__ + "img/chevron-left-pagination.408783fe.svg";